import * as graphql from 'generated/graphql';
import { useTranslation } from 'react-i18next';
import SidebarSectionHeader from './SectionHeader';
import { useState } from 'react';
import styled from 'styled-components';
import { Flex } from 'reflexbox';
import { Avatar, Paragraph, QuillText, Subheading } from '@treams/treams-ui';
import moment from 'moment';

const ComplimentDateLabel = styled(Paragraph)`
	opacity: 0;
	transition: 250ms opacity ease-out;
	font-size: 12px;
`;

const ComplimentListItemContainer = styled(Flex)`
	page-break-inside: avoid;
	margin-bottom: 10px;

	:hover {
		${ComplimentDateLabel} {
			opacity: 1;
		}
	}
`;

function ComplimentListItem(props: { compliment: graphql.Compliment }) {
	return (
		<ComplimentListItemContainer alignItems="left" justifyContent="left">
			<Avatar
				user={props.compliment.sender}
				size={32}
				flexGrow={0}
				flexShrink={0}
				marginRight="10px"
			/>

			<Flex alignItems="left" flexDirection="column" flexGrow={1}>
				<Flex justifyContent="space-between" alignItems="center">
					<Subheading>
						{props.compliment.sender.firstName} {props.compliment.sender.lastName}
					</Subheading>
					<ComplimentDateLabel>
						{moment(props.compliment.createdAt).format('LL')}
					</ComplimentDateLabel>
				</Flex>
				{props.compliment.text && (
					<Paragraph mt={2} marginTop={0}>
						<QuillText value={props.compliment.text} />
					</Paragraph>
				)}
			</Flex>
		</ComplimentListItemContainer>
	);
}

export default function SidebarComplimentSection(props: { userID: string }) {
	const { t } = useTranslation();
	const userCompliments = graphql.useUserComplimentsQuery({
		variables: { id: props.userID },
	});

	const compliments = userCompliments.data?.user.compliments.edges.slice().reverse() || [];

	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<SidebarSectionHeader isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
				{t('conversation.sidebar.compliments.title')}
			</SidebarSectionHeader>
			{isOpen &&
				(compliments.length ? (
					compliments?.map(({ node }) => (
						<ComplimentListItem key={node.id} compliment={node as graphql.Compliment} />
					))
				) : (
					<Paragraph marginBottom={10}>{t('conversation.sidebar.compliments.empty')}</Paragraph>
				))}
		</>
	);
}
